export const getToken = () => localStorage.getItem('token')
export const setToken = (token: string) => localStorage.setItem('token', token)
export const removeToken = () => localStorage.removeItem('token')

import api from '../services/api'

// 验证 token 的有效性
export const validateToken = async (): Promise<boolean> => {
  try {
    const token = getToken()
    if (!token) {
      return false
    }

    const response = await api.validateToken()
    return response.data.code === 200
  } catch (error) {
    console.error('Token 验证失败:', error)
    return false
  }
}
